"use client";
import { OspToastView } from "../toast/toastView";

export const UiContext = () => {
  return (
    <>
      <OspToastView />
    </>
  );
};
